import { Capacitor, FilesystemDirectory } from '@capacitor/core'
import { FileOpener } from '@ionic-native/file-opener'
import { saveAs } from 'file-saver'

const stringToBlob = (data: string, mimeType: string): Blob => {
  const byteString = atob(data)

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], {type: mimeType})
}

export const pdfDownloadAction = async (base64: string, filename?: string) => {
    const path = filename || 'document.pdf'

  if (Capacitor.getPlatform() === 'web') {
    saveAs(
      stringToBlob(base64, 'application/pdf'),
      path,
    )
    return
  }

  if (!Capacitor.Plugins) {
    console.error('no plugin found for file access')
    return
  }

  try {
    const c = await Capacitor.Plugins.Filesystem.writeFile({
      data: `data:application/pdf;base64,${base64}`,
      recursive: true,
      path,
      directory: FilesystemDirectory.Documents
    } as any)

    console.log('download done', c)
  } catch (e) {
    alert('failed: ' +e.message)
    return
  }

  const uri = await Capacitor.Plugins.Filesystem.getUri({
    directory: FilesystemDirectory.Documents,
    path
  })

  await FileOpener.open(uri.uri, 'application/pdf').catch(e => alert(e))
}
